import React from "react";
import { useComplaintDialog } from "./DialogContext";
import { ComplaintModalLayout } from "./ComplaintModalLayout";

ComplaintModalLayout.Content = function Content({ children }) {
  const { successView } = useComplaintDialog();

  return (
 <div className={`${successView ? "max-h-[65vh]" : "max-h-[70vh]"} px-2 overflow-auto`}>
      <div className="view-dialog-content-wrap">{children}</div>
    </div>
  );
};